/**
 * created by lei lei on 2020/5/29
 * 活动完成情况组件
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import send from './img/s3.png';
import commit from './img/s4.png';
import completed from './img/s1.png';
import progress from './img/s2.png';
import { Col, Radio, Row, Tabs } from 'antd';


const tabs = [
    {
        tab: '本周',
        key: '本周'
    },
    {
        tab: '本月',
        key: '本月'
    },
    {
        tab: '本年',
        key: '本年'
    },
    {
        tab: '历年',
        key: '历年'
    }
];
const { TabPane } = Tabs;
class ActivityCompletion extends Component {
    static defaultProps = {}
    static propTypes = {
        leftTitleList: PropTypes.array.isRequired,//左侧展示数据数组
        leftNumKey: PropTypes.string.isRequired,//左侧展示数据的键值，自定义必须穿
        //option:PropTypes.object.isRequired,//图标的数据来源这个是必须属性，但是加了会报错，数据必须传递
        topBtnClick: PropTypes.func.isRequired,//顶部按钮点击后的回调
    }

    constructor(props) {
        super(props);
        this.state = {
            btnText: '本周'
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    handleSizeChange = key => {
        this.setState({ btnText: key });
        this.props.topBtnClick && this.props.topBtnClick(key)
    };
    componentWillReceiveProps(nextProps, nextContext) {
        //console.log(nextProps)
    }

    render() {
        const option = this.props.opetion
        let newSecondSelectColor = this.props.newSecondSelectColor
        return (
            <div className={'ActivityCompletion'} style={{ height: 375, background: 'white', paddingTop:20, width: '100%', position: 'relative' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: 100, display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        {this.props.leftTitleList.map((item, i) => {
                            let img
                            let statusText
                            switch (i) {
                                case 0:
                                    // img=  <img  style={{width:46,height:46}} src={send} alt=""/>
                                    statusText = '已发派'
                                    break;
                                case 1:
                                    //   img=  <img  style={{width:46,height:46}} src={commit} alt=""/>
                                    statusText = '已提交'
                                    break;
                                case 2:
                                    //   img=  <img  style={{width:46,height:46}} src={completed} alt=""/>
                                    statusText = '已完成'
                                    break;
                                case 3:
                                    //   img=  <img  style={{width:46,height:46}} src={progress} alt=""/>
                                    statusText = '进行中'
                                    break;
                            }
                            return (
                                <div key={i} style={{ marginTop: 8 }}>
                                    <div style={{ width: 100, height: 60, background: '#f8fafd', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {/* <div style={{float:'left',height:76,lineHeight:'76px',marginLeft:20}}>
                                            {img}
                                        </div> */}
                                        {/* <div > */}
                                        <span style={{ marginRight: 10, fontSize: 12, color: '#666666', fontFamily: 'MicrosoftYaHei' }}>{statusText}</span>
                                        <span style={{ fontSize: 20, color: '#333e5f', fontFamily: 'MicrosoftYaHei-Bold', fontWeight: 'bolder' }}>{item}</span>
                                        {/* <div style={{fontSize:12,  textAlign: 'center'}}>{statusText}</div>
                                            <div style={{fontSize:24, textAlign: 'center'}}>{item}</div> */}

                                        {/* </div> */}
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div style={{ height: 350, width: '100%' }}>
                        <ReactEcharts
                            option={option}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </div>
                    <div style={{ height: 32, width: 250, position: 'absolute', right: 10, top: 0 }}>
                        <Tabs activeKey={this.state.btnText} onChange={this.handleSizeChange} className="activity-compolete-tabs">
                            {
                                tabs && tabs.length > 0 && tabs.map((item => (
                                    <TabPane tab={item.tab} key={item.tab} />
                                )))
                            }

                        </Tabs>
                        <style>
                            {`
                            .activity-compolete-tabs .ant-tabs-nav .ant-tabs-tab{
                                margin: 0;
                                color:#9ea5bd
                            }
                            .activity-compolete-tabs .ant-tabs-bar {
                                border: none
                            }
            
            .activity-compolete-tabs .ant-tabs-tab-active {
                 color: ${newSecondSelectColor} !important;
                 font-weight: bolder
             }
             .activity-compolete-tabs .ant-tabs-nav .ant-tabs-tab:hover {
                 color: ${newSecondSelectColor} !important;
             }
             .activity-compolete-tabs .ant-tabs-ink-bar{
             background-color:${newSecondSelectColor} !important;
             height: 3px;
             }
                              `}
                        </style>
                        {/* <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}>
                                <Radio.Button value="本周">本周</Radio.Button>
                                <Radio.Button value="本月">本月</Radio.Button>
                                <Radio.Button value="本年">本年</Radio.Button>
                                <Radio.Button value="历年">历年</Radio.Button>
                            </Radio.Group> */}
                    </div>


                </div>
            </div>
        )
    }

}

export default ActivityCompletion